import React, {useContext, useState, useEffect} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../.../../../../../util/ErrorBoundaryForComponents';
import {useDispatch, useSelector} from 'react-redux';
import FilterGroupSearchTable from './FilterGroupSearchTable';
import {ThemeContext} from '../../../.../../../../../themes/ThemeProvider';
import {FILE_TYPE} from '../../../.../../../../../constants/Lookup';
import {getOptions} from '../../../.../../../../../util/GetDropDownOptions';
import {getDropDownData} from '../../../.../../../../../redux/reducers/BRE/AddRecordFormat';
import * as Yup from 'yup';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
const SearchFilterGroupContainer = ({
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setSelectedFilterGroupCode,
  setFilterGroupCode,
  setSelectedRows,
  selectedRows,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const schema = Yup.object().shape({
    code: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'White space and special character are not allowed',
    ),
  });
  const initialValues = {
    code: '',
    fileType: '',
    description: '',
  };

  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  const handleReset = (values) => {
    setSearchData(initialValues);
  };

  const handleSubmit = (data) => {
    setSubmit(true);
    setSearchData(data);
  };
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  const {dropDownData} = useSelector(({addRecordFormat}) => addRecordFormat);
  return (
    <div>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
        onReset={() => handleReset()}
      >
        {(props) => {
          const {values, handleChange, handleReset, handleBlur, setFieldValue, touched, errors} =
            props;
          return (
            <div>
              <Form autoComplete="off" noValidate onReset={handleReset}>
                <ErrorBoundaryForComponents>
                  <Grid container className="global-field-textfields" spacing={2}>
                    <>
                      <Grid item xs={6} xl={4} md={4} className="form-group">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Record Format Code`}
                          label="Record Format Code"
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="code"
                          value={values?.code?.toUpperCase()}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.code}
                          error={Boolean(touched.code && errors.code)}
                        />
                        <FormHelperText>
                          {touched.code && errors.code && errors.code}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={6} xl={4} md={4} className="form-group">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Record Format Description`}
                          label="Record Format Description"
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6} xl={4} md={4} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="fileType"
                          id="fileType"
                          size="small"
                          value={values.fileType}
                          options={getOptions(FILE_TYPE, dropDownData)}
                          getOptionDisabled={(option) => option.valueCode === null}
                          getOptionLabel={(option) => {
                            return option && option.valueCode && option.value ?
                              option.value :
                              option.value === null ?
                                option.valueCode :
                                option.value;
                          }}
                          required
                          onChange={(e, value) => {
                            setFieldValue('fileType', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName} ${classes.selectLabel}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="File Type"
                                placeholder="Select File Type"
                              />
                            </div>
                          )}
                        />
                      </Grid>
                    </>
                  </Grid>
                </ErrorBoundaryForComponents>

                <div className="button-table-spacing-mb">
                  <Button
                    variant="outlined"
                    className={`mx-1 reset-btn ${classes.buttonRoot}`}
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                  >
                    Search
                  </Button>
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
      <FilterGroupSearchTable
        setFilterGroupCode={setFilterGroupCode}
        setSelectedFilterGroupCode={setSelectedFilterGroupCode}
        setTabValue={setTabValue}
        submit={submit}
        setSubmit={setSubmit}
        searchData={searchData}
        handleClose={handleClose}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        setRecordFormatFilterGroupCode={setRecordFormatFilterGroupCode}
      />
    </div>
  );
};

export default SearchFilterGroupContainer;
